import { render, staticRenderFns } from "./DownloadHomePage.vue?vue&type=template&id=47f7a9af&scoped=true&"
import script from "./DownloadHomePage.vue?vue&type=script&lang=js&"
export * from "./DownloadHomePage.vue?vue&type=script&lang=js&"
import style0 from "./DownloadHomePage.vue?vue&type=style&index=0&id=47f7a9af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f7a9af",
  null
  
)

export default component.exports